import { render, staticRenderFns } from "./GestionOferta.vue?vue&type=template&id=4ae87c18&"
import script from "./GestionOferta.vue?vue&type=script&lang=js&"
export * from "./GestionOferta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports